import type { Project } from './project';

const events = [
  { id:'d7', offset:-7, time:'090000', title:'D-7 · 사다리차·엘리베이터 예약 확인' },
  { id:'d1', offset:-1, time:'180000', title:'D-1 · 업체 회신과 잔금 시점 다시 보기' },
  { id:'day', offset:0, time:'073000', title:'당일 · 추가 요청 전 금액과 조건 확인' }
] as const;

export const dayChecks = events.map(({ id, title }) => [id, title] as const);
export function serviceDayChecks(packId:string){return packId==='cleaning'?[
  ['d7','D-7 · 청소 범위와 방문 일정 확인'],
  ['d1','D-1 · 업체 회신과 준비할 것 다시 보기'],
  ['day','당일 · 작업 시작 전 범위와 추가 금액 확인']
] as const:dayChecks;}

function localDate(date:string, offset:number) {
  const [year, month, day] = date.split('-').map(Number);
  const value = new Date(Date.UTC(year, month - 1, day + offset));
  return `${value.getUTCFullYear()}${String(value.getUTCMonth() + 1).padStart(2, '0')}${String(value.getUTCDate()).padStart(2, '0')}`;
}

function escapeIcs(value:string) {
  return value.replace(/\\/g, '\\\\').replace(/,/g, '\\,').replace(/;/g, '\\;').replace(/\n/g, '\\n');
}

export function buildCalendar(project:Project) {
  if (!project.moveDate) throw new Error(project.packId==='cleaning'?'청소 방문일을 먼저 정해 주세요.':'이사일을 먼저 정해 주세요.');
  return [
    'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//MUNOPS//Hwakdap//KO', 'CALSCALE:GREGORIAN',
    ...events.flatMap((event) => [
      'BEGIN:VEVENT',
      `UID:${project.id}-${event.id}@hwakdap.com`,
      `SUMMARY:${escapeIcs(serviceDayChecks(project.packId).find(([id])=>id===event.id)?.[1]??event.title)}`,
      `DTSTART;TZID=Asia/Seoul:${localDate(project.moveDate!, event.offset)}T${event.time}`,
      'END:VEVENT'
    ]),
    'END:VCALENDAR'
  ].join('\r\n');
}

export function singleCalendar(date:string,title='적힌대로 확인일'){
 if(!/^\d{4}-\d{2}-\d{2}$/.test(date))throw new Error('확인일을 적으면 캘린더에 넣을 수 있어요.');
 return ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//MUNOPS//Hwakdap//KO','CALSCALE:GREGORIAN','BEGIN:VEVENT',`UID:${crypto.randomUUID()}@hwakdap.com`,`DTSTAMP:${new Date().toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,'')}`,`SUMMARY:${escapeIcs(title)}`,`DTSTART;TZID=Asia/Seoul:${date.replaceAll('-','')}T090000`,'END:VEVENT','END:VCALENDAR'].join('\r\n');
}
export function googleCalendarUrl(date:string,title='적힌대로 확인일'){const stamp=date.replaceAll('-','')+'T090000';return `https://calendar.google.com/calendar/render?${new URLSearchParams({action:'TEMPLATE',text:title,dates:`${stamp}/${date.replaceAll('-','')}T093000`,ctz:'Asia/Seoul'})}`;}
